module.exports = __webpack_public_path__ + "static/media/Telus_One_page-21.70341374.png";